export const verifyEmailConstraint = (email: string) => {
  return email.includes('@');
};
